var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXLogoBw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 0c6.627 0 12 5.373 12 12h-.002c0 6.06-4.492 11.072-10.328 11.885a12.2 12.2 0 0 1-3.593-.038C4.364 22.927 0 17.972 0 12 0 5.373 5.373 0 12 0m-1.6 12.691-5.568 6.017h1.253l4.875-5.268 3.938 5.268h4.264l-5.844-7.816 5.183-5.6h-1.254l-4.488 4.85-3.627-4.85H4.866zm6.918 5.093H15.36L6.71 6.214h1.959z"
})));
export default SvgXLogoBw;